import React from "react";
import { Heading, Table, Thead, Tbody, Text, Tr, Th, Td, TableContainer, Center } from "@chakra-ui/react"
import './TablePerSKU.css';

const TablePerSKU = ({ summary }) => {
    // console.log("Summary", summary);


    const getRowBgColor = (item) => {
        if (item.added > 0 || item.exclusiveToDataTable) {
            return { bg: 'rgba(255, 0, 0, 0.5)', font: 'white' }; // Red background if AGR > 0 or exclusive to dataTable
        } else if (item.orderedQty === item.foundQty) {
            return { bg: 'rgba(166, 242, 141, 0.5)', font: 'white' }; // Light green background if ESP equals ENC
        }
        return 'transparent'; // Default background
    };
    const getContent = (value, item, column) => {
        if (item.added > 0 && column === 'AGR') {
            return <Text fontSize='5xl'>{value}</Text>; // Font size 5xl for AGR if AGR > 0
        } else if (item.exclusiveToDataTable && (column === 'ENC' || column === 'Fatn')) {
            return null; // Hide content for ENC and Fatn if exclusiveToDataTable
        } else if (value === 0) {
            return <Text fontSize='sm'>{value}</Text>; // Font size sm if value is 0
        }
        return <Text fontSize='3xl'>{value}</Text>; // Default font size for all other cases
    };
    return (<TableContainer maxHeight="400px" overflowY="auto">
        <Table variant='simple' className="tablePerSKU">

            <Thead>
                <Tr>
                    <Th width="80%"><Heading size='sm' >SKU</Heading></Th>
                    <Th width="10%" ><Heading size='sm'>Esp</Heading></Th>
                    <Th width="10%"><Heading size='sm' color='green'>Enc</Heading></Th>
                    <Th width="10%"><Heading size='sm' color='blue'>Fatn</Heading></Th>
                    <Th width="10%"><Heading size='sm' color='red'>Agr</Heading></Th>
                </Tr>
            </Thead>
            <Tbody>
                {summary && summary.length > 0 && summary.map((item, index) => (
                    <Tr key={index} bgColor={getRowBgColor(item).bg} /* color={getRowBgColor(item).font} */>
                        <Td><Center>{item.sku}</Center></Td>
                        <Td><Center>{getContent(item.orderedQty, item, 'ESP')}</Center></Td>
                        <Td><Center>{getContent(item.foundQty, item, 'ENC')}</Center></Td>
                        <Td><Center>{getContent(item.missing, item, 'Fatn')}</Center></Td>
                        <Td><Center>{getContent(item.added, item, 'AGR')}</Center></Td>
                    </Tr>
                ))}
            </Tbody>
        </Table>
    </TableContainer>);
}

export default TablePerSKU;
